import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Logo from './Logo';

const FooterContainer = styled.footer`
  background-color: var(--black);
  color: var(--white);
  padding: 4rem 0 2rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterHeading = styled.h4`
  color: var(--primary);
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
`;

const FooterLink = styled(Link)`
  color: var(--gray-400);
  margin-bottom: 0.75rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--primary);
  }
`;

// Helper for scroll-to-top on link click
const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

const FooterText = styled.p`
  color: var(--gray-400);
  margin-bottom: 1rem;
  font-size: 0.9rem;
  line-height: 1.5;
`;

const Copyright = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 2rem 0;
  text-align: center;
  color: var(--gray-500);
  font-size: 0.9rem;
  border-top: 1px solid var(--gray-800);
  margin-top: 3rem;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterColumn>
          <Logo color="white" height="30px" fullName={true} />
          <FooterText>
            Platform0 provides cutting-edge architecture as a service and AI consultancy to help businesses innovate and scale efficiently.
          </FooterText>
          {/* <SocialLinks>
            <SocialIcon href="https://twitter.com/platform0" target="_blank" rel="noopener noreferrer">𝕏</SocialIcon>
            <SocialIcon href="https://linkedin.com/company/platform0" target="_blank" rel="noopener noreferrer">in</SocialIcon>
            <SocialIcon href="https://github.com/platform0" target="_blank" rel="noopener noreferrer">GH</SocialIcon>
          </SocialLinks> */}
        </FooterColumn>
        
        <FooterColumn>
          <FooterHeading>Services</FooterHeading>
          <FooterLink to="/services#architecture">Architecture as a Service</FooterLink>
          <FooterLink to="/services#ai-consultancy">AI Consultancy</FooterLink>
          <FooterLink to="/services#cloud-solutions">Cloud Solutions</FooterLink>
          <FooterLink to="/services#digital-transformation">Digital Transformation</FooterLink>
        </FooterColumn>
        
        <FooterColumn>
          <FooterHeading>Company</FooterHeading>
          <FooterLink to="/about" onClick={scrollToTop}>About Us</FooterLink>
          <FooterLink to="/use-cases" onClick={scrollToTop}>Use Cases</FooterLink>
          <FooterLink to="/book" onClick={scrollToTop}>Without Chaos: The AI Catalyst</FooterLink>
        </FooterColumn>
        
        <FooterColumn>
          <FooterHeading>Contact</FooterHeading>
          <FooterText>hello@platform0.ca</FooterText>
          <FooterLink to="/contact" onClick={scrollToTop}>Contact Us</FooterLink>
        </FooterColumn>
      </FooterContent>
      
      <Copyright>
        <p>&copy; {currentYear} Platform0. All rights reserved.</p>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
